export default __webpack_public_path__ + "static/media/vectors.88d54852.svg";